import { Action } from "../../../actions/actions";
import { AuthActionTypes } from "../actions/actionTypes";

// export interface User {
//     id: number;
//     first_name: string;
//     last_name: string;
//     email: string;
//     is_active: boolean;
//     date_joined: string;
// }

const initialState = [];

export function rolesReducer(state = initialState, action: Action) {
    switch (action.type) {
        case AuthActionTypes.GET_ROLES_LIST_SUCCESS:
            //let roles_array = []
            //roles_array = action.payload.results.filter(role=>role.permission_spec.domains.route.type==="glob")
            //roles_array = roles_array.concat(action.payload.results.filter(role=>role.permission_spec.domains.route.type!=="glob"))
            return {
                total_number_of_roles: action.payload.count,
                //roles_array: roles_array
                roles_array: action.payload.results
            };
        default:
            return state;
    }
}

export function rolesLoading(state: boolean = true, action: Action) {
    switch (action.type) {
        case AuthActionTypes.GET_ROLES_LIST:
            return true;

        case AuthActionTypes.GET_ROLES_LIST_SUCCESS:
        case AuthActionTypes.GET_ROLES_LIST_FAIL:
            return false;

        default:
            return state;
    }
}

export function shouldCloseDrawer(state: boolean = false, action: Action) {
    switch (action.type) {
        case AuthActionTypes.OPEN_DRAWER:
        case AuthActionTypes.CREATE_ROLE:
        case AuthActionTypes.EDIT_ROLE:
        case AuthActionTypes.CREATE_ROLE_FAIL:
        case AuthActionTypes.EDIT_ROLE_FAIL:
            return false;

        case AuthActionTypes.CREATE_ROLE_SUCCESS:
        case AuthActionTypes.EDIT_ROLE_SUCCESS:
            return true;

        default:
            return state;
    }
}

export function resourceEntity(state = initialState, action: Action) {
    switch (action.type) {
        case AuthActionTypes.GET_RESOURCE_ENTITY_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
